// Shared column widths keep the distributions aligned with the table, even
// when it is sorted or scrolled. Every numeric column has its own value scale.
export function runDistributions(columns, trials) {
    let left = 0;
    return columns.map((column) => {
        const x = left + column.width / 2;
        left += column.width;
        if (column.text || column.key === 'number') return null;
        const values = trials.filter((row) => row.status !== 'running').map(column.value).filter(Number.isFinite);
        const min = values.length ? Math.min(...values) : null;
        const max = values.length ? Math.max(...values) : null;
        const fraction = (value) => !Number.isFinite(value) || min == null ? null : max === min ? 0.5 : (value - min) / (max - min);
        const bins = Array(8).fill(0);
        values.forEach((value) => { bins[Math.min(7, Math.floor(fraction(value) * 8))] += 1; });
        return { ...column, x, min, max, fraction, bins, count: values.length };
    }).filter(Boolean);
}

export function runLinePath(axes, row, top, height) {
    let connected = false;
    return axes.map((axis, index) => {
        const value = axis.fraction(axis.value(row));
        if (value == null) { connected = false; return ''; }
        const y = top + (1 - value) * height;
        const previous = axes[index - 1];
        const command = connected ? `C${(previous.x + axis.x) / 2},${top + (1 - previous.fraction(previous.value(row))) * height} ${(previous.x + axis.x) / 2},${y} ${axis.x},${y}` : `M${axis.x},${y}`;
        connected = true;
        return command;
    }).join(' ');
}
